<template>
  <div id="CoursewareNewAdd" v-loading="loading" class="mainDiv">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      style="padding: 0 20px"
    >
      <!--      <el-form-item label="课件库信息" style="font-weight: bold;">-->
      <!--      </el-form-item>-->
      <el-form-item
        label="课件库名称："
        :required="true"
        style="display: inline-block"
      >
        <el-input
          v-model="form.name"
          v-bind:disabled="isChanges"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="办学形式："
        :required="true"
        style="display: inline-block"
      >
        <el-checkbox-group v-model="form.type">
          <el-checkbox
            :label="types.typeCode"
            :value="types.id"
            name="type"
            v-for="(types, index) in typeLists"
            :key="index"
            v-bind:disabled="issDisabled"
          >
            {{ types.typeName }}</el-checkbox
          >
          <!--<el-checkbox label="2" name="type" v-bind:disabled="issDisabled">成教教育</el-checkbox>-->
          <!--<el-checkbox label="3" name="type" v-bind:disabled="issDisabled">网络教育</el-checkbox>-->
          <!--<el-checkbox label="4" name="type" v-bind:disabled="issDisabled">高端培训</el-checkbox>-->
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="关联课程：" :required="true">
        <div>
          <div v-show="linkSelf.length > 0 ? true : false">
            <label for="" style="vertical-align: top">自学考试:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkSelf"
                :key="index"
                style="margin-right: 5px"
                >{{ item.courseName }},</span
              >
            </div>
          </div>
          <div v-show="linkAdult.length > 0 ? true : false">
            <label for="" style="vertical-align: top">成人教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkAdult"
                :key="index"
                style="margin-right: 5px"
                >{{ item.courseName }},</span
              >
            </div>
          </div>
          <div v-show="linkNet.length > 0 ? true : false">
            <label for="" style="vertical-align: top">网络教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkNet"
                :key="index"
                style="margin-right: 5px"
                >{{ item.courseName }},</span
              >
            </div>
          </div>
          <div v-show="linkTrain.length > 0 ? true : false">
            <label for="" style="vertical-align: top">高端培训:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkTrain"
                :key="index"
                style="margin-right: 5px"
                >{{ item.courseName }},</span
              >
            </div>
          </div>
        </div>
        <el-button type="primary" @click="linkCourse" v-show="isChoose">{{
          chooseCousres
        }}</el-button>
      </el-form-item>
      <el-form-item label="关联专业：">
        <div>
          <div v-show="linkSelf.length > 0 ? true : false">
            <label for="" style="vertical-align: top">自学考试:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <!--<span v-for="(item,index) in majorSelf" :key="index" style="margin-right: 5px;">{{item}},</span>-->
              <span
                v-for="(item, index) in linkSelf"
                :key="index"
                style="margin-right: 5px"
                >{{ item.majorName }},</span
              >
            </div>
          </div>
          <div v-show="linkAdult.length > 0 ? true : false">
            <label for="" style="vertical-align: top">成人教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <!--<span v-for="(item,index) in majorAdult" :key="index" style="margin-right: 5px;">{{item}},</span>-->
              <span
                v-for="(item, index) in linkAdult"
                :key="index"
                style="margin-right: 5px"
                >{{ item.majorName }},</span
              >
            </div>
          </div>
          <div v-show="linkNet.length > 0 ? true : false">
            <label for="" style="vertical-align: top">网络教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <!--<span v-for="(item,index) in majorNet" :key="index" style="margin-right: 5px;">{{item}},</span>-->
              <span
                v-for="(item, index) in linkNet"
                :key="index"
                style="margin-right: 5px"
                >{{ item.majorName }},</span
              >
            </div>
          </div>
          <div v-show="linkTrain.length > 0 ? true : false">
            <label for="" style="vertical-align: top">高端培训:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <!-- <span v-for="(item,index) in majorTrain" :key="index" style="margin-right: 5px;">{{item}},</span>-->
              <span
                v-for="(item, index) in linkTrain"
                :key="index"
                style="margin-right: 5px"
                >{{ item.majorName }},</span
              >
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="创建机构："
        :required="true"
        style="display: inline-block"
      >
        <el-input
          v-model="form.organization"
          v-bind:disabled="true"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="创建人："
        :required="true"
        style="display: inline-block"
      >
        <el-input
          v-model="form.user"
          v-bind:disabled="true"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item style="text-align: center; padding: 30px 0">
        <el-button type="primary" @click="onSubmit" v-show="changeShow1"
          >确 定</el-button
        >
        <el-button type="primary" v-show="changeShow" @click="onChange"
          >修 改</el-button
        >
        <el-button type="primary" v-show="changeShow" @click="onCourse"
          >课件管理</el-button
        >
        <el-button type="" v-show="ifGetBack && !courseWareId" @click="getBack"
          >返 回</el-button
        >
      </el-form-item>
    </el-form>
    <Courseware-review-edit
      v-if="isShowDialog"
      ref="CoursewareReviewEdit"
      @sendSelfStudy="sendSelfStudy"
      @sendSelfStudy2="sendSelfStudy2"
      @sendAdultStudy="sendAdultStudy"
      @sendAdultStudy2="sendAdultStudy2"
      @sendNetStudy="sendNetStudy"
      @sendNetStudy2="sendNetStudy2"
      @sendTrainStudy="sendTrainStudy"
      @sendTrainStudy2="sendTrainStudy2"
      :code="form.type"
      :key="componentKey"
      :linkSelf="linkSelf"
      :linkAdult="linkAdult"
      :linkNet="linkNet"
      :linkTrain="linkTrain"
      :data1="data1"
      :data2="data2"
      :data3="data3"
      :data4="data4"
    ></Courseware-review-edit>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/coursewareList'
import CoursewareReviewEdit from './Courseware-edit'
export default {
  name: 'CoursewareNewAdd',
  inject: ['reload'],
  components: {
    CoursewareReviewEdit,
  },
  props: ['courseWareId', 'isCurrentComponent'],
  data() {
    return {
      chooseCousres: '请选择课程',
      componentKey: 0,
      isChoose: true,
      issDisabled: false,
      isChanges: false,
      ifGetBack: true,
      changeShow: true,
      changeShow1: true,
      changeShow2: true,
      loading: false,
      form: {
        name: '',
        type: [],
        organization: '',
        user: '',
      },
      isShowDialog: false,
      linkSelf: [],
      linkAdult: [],
      linkNet: [],
      linkTrain: [],
      majorSelf: [],
      majorAdult: [],
      majorNet: [],
      majorTrain: [],
      professionSelf: [],
      professionAdult: [],
      professionNet: [],
      professionTrain: [],
      arrSelf: [],
      arrAdult: [],
      arrNet: [],
      arrTrain: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      institutionId: '',
      id: '',
      typeLists: [],
      values: [],
      labels: [],
      courseId: null,
      userType: '',
    }
  },
  methods: {
    forceRerender() {
      //强制组件重新加载
      this.componentKey += 1
    },
    // 获取数据
    getList() {
      this.loading = true
      this.getEducationType()
      this.getUserByUid()
      this.getSchoolByUid()
      if (this.courseWareId) {
        this.id = this.courseWareId
      } else {
        this.id = this.$route.params.id || this.$route.query.id || ''
      }
      this.courseId = this.$route.params.courseId
      console.log('this.courseId', this.courseId)
      if (this.id == '') {
        //新增
        this.issDisabled = false
        this.isChanges = false
        this.changeShow = false
        // this.changeShow2 = true
        this.isChoose = true
        this.loading = false
        // this.ifGetBack = true
        // this.getUserByUid()
        // this.getSchoolByUid()
      } else {
        //详情
        api.viewCourseWare(this.id).then(({ data }) => {
          console.log(12333)
          if (data.code == 100000) {
            this.issDisabled = true
            this.isChanges = true
            this.isChoose = false
            this.changeShow = true
            this.changeShow1 = false
            // this.changeShow2 = true
            data = data.data
            console.log(data)
            this.id = data.id
            this.form.name = data.wareName || ''
            this.form.user = data.uname || ''
            this.form.organization = data.institutionName || ''
            for (let i = 0; i < data.zkolCoursewareLearntypeRefs.length; i++) {
              this.form.type.push(
                data.zkolCoursewareLearntypeRefs[i].zkolBaseDictTypeVO.typeCode
              )
            }
            let linkData = data.zkolCourseCoursewareRefs || ''
            for (let i = 0; i < linkData.length; i++) {
              if (
                linkData[i].zkolBaseCourseVO.educationTypeName == '自学考试'
              ) {
                this.linkSelf.push(linkData[i].zkolBaseCourseVO)
              } else if (
                linkData[i].zkolBaseCourseVO.educationTypeName == '成人教育'
              ) {
                this.linkAdult.push(linkData[i].zkolBaseCourseVO)
              } else if (
                linkData[i].zkolBaseCourseVO.educationTypeName == '网络教育'
              ) {
                this.linkNet.push(linkData[i].zkolBaseCourseVO)
              } else if (
                linkData[i].zkolBaseCourseVO.educationTypeName == '高端培训'
              ) {
                this.linkTrain.push(linkData[i].zkolBaseCourseVO)
              }
            }
            this.loading = false
          }
        })
      }
    },

    getUserByUid() {
      api.getUserByUid(this.getUId).then(({ data }) => {
        data = data.data
        this.userType = data.type
        this.form.user = data.uname
      })
    },
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        data = data.data
        console.log(data)
        this.institutionId = data.id
        console.log(this.institutionId)
        this.form.organization = data.title
      })
    },
    getEducationType() {
      api.getEducationType().then(({ data }) => {
        data = data.data
        console.log(data)
        this.typeLists = data
      })
    },

    //确定
    onSubmit() {
      // const url = 'CoursewareList'
      // this.$emit('set-active-from-sub', url)
      // this.$router.push(url)
      if (
        this.form.name == '' ||
        this.form.name == null ||
        this.form.name == undefined
      ) {
        this.$message({ type: 'warning', message: '请输入课件库名称' })
      } else if (
        this.form.organization == '' ||
        this.form.organization == null ||
        this.form.organization == undefined
      ) {
        this.$message({ type: 'warning', message: '请输入创建机构' })
      } else if (
        this.form.user == '' ||
        this.form.user == null ||
        this.form.user == undefined
      ) {
        this.$message({ type: 'warning', message: '请输入创建人' })
      } else if (this.form.type.length == 0) {
        this.$message({ type: 'warning', message: '请选择办学形式' })
      } else if (
        this.linkSelf.length == 0 &&
        this.linkAdult.length == 0 &&
        this.linkNet.length == 0 &&
        this.linkTrain.length == 0
      ) {
        this.$message({ type: 'warning', message: '请选择关联课程' })
      } else {
        let courseIds = ''
        if (this.linkSelf.length > 0) {
          for (let i = 0; i < this.linkSelf.length; i++) {
            courseIds += this.linkSelf[i].courseId + ','
          }
        }
        if (this.linkAdult.length > 0) {
          for (let j = 0; j < this.linkAdult.length; j++) {
            courseIds += this.linkAdult[j].courseId + ','
          }
        }
        if (this.linkNet.length > 0) {
          for (let k = 0; k < this.linkNet.length; k++) {
            courseIds += this.linkNet[k].courseId + ','
          }
        }
        if (this.linkTrain.length > 0) {
          for (let h = 0; h < this.linkTrain.length; h++) {
            courseIds += this.linkTrain[h].courseId + ','
          }
        }
        let typeArr = []
        let learnTypeId = ''
        for (let a = 0; a < this.form.type.length; a++) {
          for (let b = 0; b < this.typeLists.length; b++) {
            if (this.typeLists[b].typeCode == this.form.type[a]) {
              typeArr.push(this.typeLists[b])
            }
          }
        }
        for (let c = 0; c < typeArr.length; c++) {
          learnTypeId += typeArr[c].id + ','
        }

        let formData = new FormData()
        formData.append('id', this.id)
        formData.append('wareName', this.form.name)
        formData.append('institutionId', this.institutionId)
        formData.append('createName', this.form.user)
        formData.append('createId', this.getUId)
        formData.append('learnTypeId', learnTypeId)
        formData.append('courseId', courseIds)
        formData.append('userType', this.userType)
        api.addCourseWare(formData).then(({ data }) => {
          if (data.code !== 100000) {
            this.$message({ type: 'error', message: data.msg })
          } else {
            this.$message({ type: 'success', message: '提交成功' })
            if (!this.courseWareId) {
              let that = this
              setTimeout(function () {
                that.$router.go(-1)
              }, 500)
            } else {
              this.issDisabled = true
              this.isChoose = false
              this.changeShow = true
              this.changeShow1 = false
              this.ifGetBack = false
            }
          }
        })
      }
    },

    // 修改
    onChange() {
      this.issDisabled = false
      this.isChoose = true
      this.isChanges = true
      this.changeShow = false
      this.changeShow1 = true
      this.ifGetBack = true
    },

    onCourse() {
      if (this.isCurrentComponent) {
        this.$emit('jumpToCoursewareManager')
      } else {
        this.$router.push({
          name: 'CheckCourseware',
          query: {
            type: 'third',
            id: this.id,
          },
        })
      }
    },
    getBack() {
      this.issDisabled = true
      this.isChoose = false
      this.changeShow = true
      this.ifGetBack = false
      const url = 'CoursewareList'
      this.$emit('set-active-from-sub', url)
      this.$router.push({
        name: url,
      })
    },

    //    点击关联课程按钮
    linkCourse() {
      this.isShowDialog = true
      this.forceRerender()
      this.$nextTick(() => {
        this.$refs.CoursewareReviewEdit.init(this.form.type)
      })
    },
    sendSelfStudy(data) {
      this.chooseCousres = '请重新选择课程'
      console.log(data + '-----------------this.courseSelf')
      // this.linkSelf = data
      // console.log(this.linkSelf);
      this.linkSelf = []
      this.data1 = data
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < this.arrSelf.length; j++) {
          if (this.arrSelf[j].courseId == data[i]) {
            this.linkSelf.push(this.arrSelf[j])
          }
        }
      }
    },
    sendSelfStudy2(data) {
      console.log(data + '-----------this.selfList')
      this.arrSelf = data
    },

    sendAdultStudy(data) {
      this.chooseCousres = '请重新选择课程'
      this.linkAdult = []
      this.data2 = data
      for (let i = 0; i < data.length; i++) {
        // this.linkAdult.push(this.arrAdult[data[i]])
        for (let j = 0; j < this.arrAdult.length; j++) {
          if (this.arrAdult[j].courseId == data[i]) {
            this.linkAdult.push(this.arrAdult[j])
          }
        }
      }
    },
    sendAdultStudy2(data) {
      this.arrAdult = data
    },

    sendNetStudy(data) {
      this.chooseCousres = '请重新选择课程'
      this.linkNet = []
      this.data3 = data
      for (let i = 0; i < data.length; i++) {
        // this.linkNet.push(this.arrNet[data[i]])
        for (let j = 0; j < this.arrAdult.length; j++) {
          if (this.arrNet[j].courseId == data[i]) {
            this.linkNet.push(this.arrNet[j])
          }
        }
      }
    },
    sendNetStudy2(data) {
      this.arrNet = data
    },

    sendTrainStudy(data) {
      this.chooseCousres = '请重新选择课程'
      this.linkTrain = []
      this.data4 = data
      for (let i = 0; i < data.length; i++) {
        // this.linkTrain.push(this.arrTrain[data[i]])
        for (let j = 0; j < this.arrTrain.length; j++) {
          if (this.arrTrain[j].courseId == data[i]) {
            this.linkTrain.push(this.arrTrain[j])
          }
        }
      }
    },
    sendTrainStudy2(data) {
      this.arrTrain = data
    },

    // sendselfMarj(data){
    //   this.majorSelf = data
    // },
    // sendadultMarj(data){
    //   this.majorAdult = data
    // },
    // sendnetMarj(data){
    //   this.majorNet = data
    // },
    // sendtrainMarj(data){
    //   this.majorTrain = data
    // },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') || '4'
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
